import { previewActions } from "../action/types";

const initialState = {
	isPreview: false,
	previewData: null,
};

const notificationPreviewReducer = (state = initialState, action) => {
	switch (action.type) {
		case previewActions.NOTIFICATION_PREVIEW_ADD: {
			const {  previewData } = action.payload;
			const object = {
                ...state,
				isPreview: true,
				previewData,
            }
			return object;
		}
		case previewActions.NOTIFICATION_PREVIEW_CLEAR: {
			const object = {
                ...state,
				isPreview: false,
				previewData: null,
            }
			return object;
		}

		default:
			return state;
	}
};

export default notificationPreviewReducer;